import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { IonicStorageModule } from '@ionic/storage';
import { MyApp } from './app.component';

// Importing plug-ins
import { Geolocation } from '@ionic-native/geolocation';
import { Network } from '@ionic-native/network';
import { SplashScreen } from '@ionic-native/splash-screen';
import { NativeAudio } from '@ionic-native/native-audio';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { GoogleAnalytics } from '@ionic-native/google-analytics';
import { SocialSharing } from '@ionic-native/social-sharing';

// Importing registration pages
import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';
// import { ResetPasswordPage } from '../pages/reset-password/reset-password';
// import { SignupPage } from '../pages/signup/signup';

//Import Components
import { ContactComponent } from '../components/contact/contact';
import { MapStaticComponent } from '../components/map-static/map-static';
import { TapRevealComponent } from '../components/tap-reveal/tap-reveal';
import { ElasticHeader } from '../components/elastic-header/elastic-header'
import { ParallaxHeader } from '../components/parallax-header/parallax-header';
import { WildlifelistComponent } from '../components/wildlifelist/wildlifelist';

// Importing providers
import { ConnectivityService } from '../providers/connectivity-service';
import { WildlifeService } from '../providers/wildlife-service';
import { Data } from '../providers/data';
import { SmartAudio } from '../providers/smart-audio';


// Import the AF2 Modules
import { AngularFireModule } from 'angularfire2';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireOfflineModule } from 'angularfire2-offline';


// AF2 Firebase Settings
export const firebaseCredential = {
   apiKey: "AIzaSyAA9PEx9tTLcVd4X699NPvMFNdBbYiCpmw",
    authDomain: "bou-bou-lodge.firebaseapp.com",
    databaseURL: "https://bou-bou-lodge.firebaseio.com",
    storageBucket: "bou-bou-lodge.appspot.com",
    messagingSenderId: "86780161550"
};

/*
const firebaseCredential= {
  provider: AuthProviders.Password,
  method: AuthMethods.Password
}
*/

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    ContactComponent,
    MapStaticComponent,
    ParallaxHeader,
    TapRevealComponent,
    WildlifelistComponent,
    ElasticHeader
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonicModule.forRoot(MyApp, {}, 
{
  links: [
    { loadChildren: '../pages/about-us/about-us.module#AboutUsModule', name: 'AboutUs', segment: 'about-us', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/accomodation/accomodation.module#AccomodationModule', name: 'SafariHolidays', segment: 'safariholidays', priority: 'low', defaultHistory: ['ExperienceUs'] },
    { loadChildren: '../pages/activities/activities.module#ActivitiesModule', name: 'Activities', segment: 'activities', priority: 'low', defaultHistory: ['ExperienceUs'] },
    { loadChildren: '../pages/conservation/conservation.module#ConservationModule', name: 'Conservation', segment: 'conservation', priority: 'low', defaultHistory: ['OurWildlife'] },
    { loadChildren: '../pages/contact-us/contact-us.module#ContactUsModule', name: 'ContactUs', segment: 'contact-us', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/daysafaris/daysafaris.module#DaysafarisModule', name: 'Daysafaris', segment: 'daysafaris', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/experience-us/experience-us.module#ExperienceUsModule', name: 'ExperienceUs', segment: 'experience-us', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/fieldguides/fieldguides.module#FieldguidesModule', name: 'Fieldguides', segment: 'fieldguides', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/gallery/gallery.module#GalleryModule', name: 'Gallery', segment: 'gallery', priority: 'low', defaultHistory: ['OurWildlife'] },
    { loadChildren: '../pages/history/history.module#HistoryModule', name: 'History', segment: 'history', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/intro/intro.module#IntroModule', name: 'Intro', segment: 'intro', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/join-us/join-us.module#JoinUsModule', name: 'JoinUs', segment: 'join-us', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/location/location.module#LocationModule', name: 'Location', segment: 'location', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/nearby/nearby.module#NearbyModule', name: 'Nearby', segment: 'nearby', priority: 'low', defaultHistory: ['AboutUs'] },
    { loadChildren: '../pages/our-wildlife/our-wildlife.module#OurWildlifeModule', name: 'OurWildlife', segment: 'our-wildlife', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/owner/owner.module#OwnerModule', name: 'Owner', segment: 'owner', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/volunteers/volunteers.module#VolunteersModule', name: 'Volunteers', segment: 'volunteers', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wildlife/wildlife.module#WildlifeModule', name: 'Wildlife', segment: 'wildlife', priority: 'low', defaultHistory: ['OurWildlife'] },
    { loadChildren: '../pages/wildlife-autocomplete/wildlife-autocomplete.module#WildlifeAutocompletePageModule', name: 'WildlifeAutocompletePage', segment: 'wildlife-autocomplete', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wildlifedetail/wildlifedetail.module#WildlifedetailModule', name: 'Wildlifedetail', segment: 'wildlifedetail', priority: 'low', defaultHistory: ['OurWildlife', 'Wildlife', 'wildlifelisting'] },
    { loadChildren: '../pages/wildlifeeditor/wildlifeeditor.module#WildlifeeditorModule', name: 'Wildlifeeditor', segment: 'wildlifeeditor', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/wildlifelisting/wildlifelisting.module#WildlifelistingModule', name: 'Wildlifelisting', segment: 'wildlifelist/:taxonomylevel', priority: 'low', defaultHistory: ['Wildlife'] }
  ]
}),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(firebaseCredential),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    AngularFireOfflineModule   
  ],
  bootstrap: [IonicApp],
 entryComponents: [
    MyApp,
    HomePage
  ],
  providers: [
    // AuthData,
    ConnectivityService,
    WildlifeService,
    Data,
    Network,
    SplashScreen,
    Geolocation,
    SmartAudio,
    NativeAudio,
    ScreenOrientation,
    GoogleAnalytics,
    SocialSharing,
    [{provide: ErrorHandler, useClass: IonicErrorHandler}]
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts